import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 py-12">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="/rectok-logo.png" 
                alt="RECfolk" 
                className="h-8 w-auto drop-shadow-[0_0_10px_rgba(255,50,37,0.5)]"
              />
            </div>
            <p className="text-white/60 leading-relaxed">
              Crafting cinematic excellence in commercials and documentaries for brands and agencies worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wide text-sm">
              Quick Links
            </h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/60 hover:text-red-600 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('showreel').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/60 hover:text-red-600 transition-colors"
                >
                  Showreel
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('portfolio').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/60 hover:text-red-600 transition-colors"
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/60 hover:text-red-600 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 uppercase tracking-wide text-sm">
              Follow Us
            </h3>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/recfolk?igsh=YmRtd3o4MXI4c3Ix"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/5 p-3 rounded-full hover:bg-red-600 transition-all duration-200 text-white hover:scale-110"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="#"
                className="bg-white/5 p-3 rounded-full hover:bg-red-600 transition-all duration-200 text-white hover:scale-110"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-white/60 text-sm">
            <div>
              © {currentYear} RECfolk. All rights reserved.
            </div>
            <div className="flex gap-6">
              <a href="#" className="hover:text-red-600 transition-colors">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-red-600 transition-colors">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
